module.exports = __webpack_public_path__ + "static/media/ico_cnf_ext-17.48880ab1.svg";